import React, { useEffect, useState, useRef } from "react";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import { useForm } from "react-hook-form";
import _ from "lodash/fp";
import html2pdf from "html2pdf.js";
import label from "../labels/statisticalReport_en.json";
import commonLabels from "../../common/labels/common_en.json";
import {
  getAdvertisementsList,
  getExamslistByAdvertisementId,
  getSubjectlistByExamId
} from "../../postExaminationProcessObjective/actions/postExaminationProcessObjectiveActions";

import { SET_PRESENT_ABSENT_COUNTS } from "../../common/constants/ActionTypes";
import {
  getPresentAbsentData
} from "../../statistical-report/actions/statisticalReportActions";
import { getYearList, getAdvertisementlistByYear } from "../../common/actions/commonActions";

const PresentAbsentReport = () => {

  const pdfRef = useRef(null);

  const { register, handleSubmit, errors, reset } = useForm(
    {
      mode: "onChange",
    }
  );


  let { advertisementList, examList, subjectList } = useSelector(
    (state) => state.postExamProcessObjectReducer,
    shallowEqual
  );
  let { yearList, allYearList } = useSelector(
    (state) => state.common,
    shallowEqual
  );
  let { statisticalReportData } = useSelector(
    (state) => state.statisticalReducer,
    shallowEqual
  );

  const [selectedAdvertNo, setSelectedAdvertNo] = useState("");
  const [selectedExam, setSelectedExam] = useState("");
  const [confirmClicked, setConfirmClicked] = useState(true);
  const [printFlag, setPrintFlag] = useState(true);
  const [selectedSubject, setSelectedSubject] = useState("");
  const [reloadItem, setReloadItem] = useState(true);
  const [saveButtonFlag, setSaveButtonFlag] = useState(true);
  const [pdfPrintDisabled, setPdfPrintDiabled] = useState(false);
  const session = JSON.parse(sessionStorage.getItem("session"));
  const dispatch = useDispatch();

  useEffect(() => {

    dispatch(getYearList());
    window.scrollTo(0, 0)
    dispatch({
      payload: {},
      type: SET_PRESENT_ABSENT_COUNTS
    })
    setReloadItem(!reloadItem);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const onAdvertisementChange = (ele) => {
    setSelectedAdvertNo(ele);
    setSelectedExam("");
    setSaveButtonFlag(true);
    setConfirmClicked(true);
    setPrintFlag(true);
    examList.length = 0;
    subjectList.length = 0;
    ele && dispatch(getExamslistByAdvertisementId(ele));
    setReloadItem(!reloadItem);
  };

  const onExamChange = (ele) => {
    setSelectedExam(ele);
    setSaveButtonFlag(false);
    setConfirmClicked(false);
    setPrintFlag(true);
    subjectList.length = 0;
    // ele && dispatch(getSubjectlistByExamId(ele));
    setReloadItem(!reloadItem);
  };
  // const onSubjectChange = (ele) => {
  //   setSelectedSubject(ele);
  //   setSaveButtonFlag(false);
  //   setConfirmClicked(false);
  //   setPrintFlag(true);

  //   setReloadItem(!reloadItem);
  // };

  const onSelectYear = (ele) => {
    let selectedValue = ele;
    selectedValue && dispatch(getAdvertisementlistByYear(selectedValue));
    if (allYearList) {
      allYearList.length = 0
    }
    if (examList) {
      examList.length = 0;
    }

    setSaveButtonFlag(true);

    setReloadItem(!reloadItem);
  };

  const onCancelButton = () => {
    // setSelectedAdvertNo("");
    // setSelectedExam("");
    // setSelectedSubject("");
    reset()
    setSaveButtonFlag(true);
    setConfirmClicked(true);
    setPrintFlag(true);
    setReloadItem(!reloadItem);
    examList.length = 0;
    subjectList.length = 0;
  };

  const genPdf = () => {
    const htmlContent = document.createElement('div');

    htmlContent.innerHTML = '<div class="row d-flex flex-column align-items-center"><h5>' + commonLabels.MPSC + '</h5><h5>' + statisticalReportData.examName + '</h5><h5>' + label.FinalPresentAbsentCount + '</h5></div>';
    htmlContent.innerHTML += pdfRef.current.innerHTML;

    const options = {
      margin: [1, 0.3, 0.5, 0.3],
      filename: "PresentAbsentReport.pdf",
      image: { type: "jpeg", quality: 0.95 },
      html2canvas: { scale: 2, dpi: 300, letterRendering: true },
      jsPDF: {
        unit: "in",
        format: "a4",
        orientation: "portrait",
        compressPDF: true,
      },
    };

    html2pdf()
      .from(htmlContent)
      .set(options)
      .toPdf()
      .get("pdf")
      .then((pdf) => {
        const totalPages = pdf.internal.getNumberOfPages();

        for (let i = 1; i <= totalPages; i++) {
          pdf.setPage(i);

          const pageWidth = pdf.internal.pageSize.getWidth();
          const pageHeight = pdf.internal.pageSize.getHeight();
          const textWidth =
            (pdf.getStringUnitWidth(`${i}`) * pdf.internal.getFontSize()) /
            pdf.internal.scaleFactor;
          const textX = pageWidth - textWidth - 1.2;
          const textY = 0.8;
          const currentDate = new Date();
          const formattedDate = currentDate.toLocaleDateString('en-GB', {
            day: '2-digit',
            month: '2-digit',
            year: 'numeric',
          }).split('/').join('/');

          const dateWidth = pdf.getStringUnitWidth(formattedDate) * pdf.internal.getFontSize() / pdf.internal.scaleFactor;
          const dateX = pageWidth - dateWidth - 0.2;
          const dateY = 0.6;
          pdf.setFontSize(8);
          pdf.text(formattedDate, dateX, dateY);
          pdf.text(`Page No. ${i}`, dateX, textY)

          const ad = statisticalReportData.advertisementNo;
          const headerText = `Advertisement No. ${ad}`;
          const headerX = 0.4;
          const headerY = 0.6;

          pdf.setFontSize(8);
          pdf.text(headerText, headerX, headerY);
        }

        pdf.save(`PresentAbsentReport.pdf`);
      });
  };

  const downloadPdf = () => {
    setPdfPrintDiabled(true);
    if (pdfRef) {
      genPdf();
    }
    setReloadItem(!reloadItem);
  };

  const onSubmit = () => {

    dispatch(getPresentAbsentData(selectedAdvertNo, selectedExam));
    setPrintFlag(false);
    setReloadItem(!reloadItem);
  };

  return (
    <div>
      <h5> {label.FinalPresentAbsentCount} </h5>
      <div className="row dashboardCards">
        <div className="col-md-12">
          <form name="importForm" encType="multipart/form-data">
            <div className="form-group importFromSection">
              <div className="row">
                <div className="form-group col-md-2">
                  <label className="float-left">
                    {commonLabels.selectYear}
                    <span className="errorText">*</span>
                  </label>
                  <select
                    className="form-control"
                    name="selectedYear"
                    ref={register({ required: true })}
                    onChange={(e) => {
                      onSelectYear(e.target.value);
                    }}
                  >
                    <option key={0} value="">
                      {commonLabels.COMBO_SELECT}
                    </option>
                    {yearList &&
                      yearList.length > 0 &&
                      yearList
                        .map((element, index) => (
                          <option>{element}</option>
                          // <option key={index} value={element.id}>
                          //   {`${element.advertisementNo}/${element.year} - ${element.name}`}
                          // </option>
                        ))}
                  </select>
                  {_.get("selectedYear.type", errors) ===
                    "required" && (
                      <p className="errorText float-left">
                        {commonLabels.MANDATORY_FIELD_MESSAGE}
                      </p>
                    )}
                </div>
                <div className="form-group col-md-5">
                  <label className="float-left">
                    {commonLabels.SelectAdvertNo}
                    <span className="errorText">*</span>
                  </label>
                  <select
                    className="form-control"
                    name="selectedAdvertiseNo"
                    ref={register({ required: true })}
                    onChange={(e) => {
                      onAdvertisementChange(e.target.value);
                    }}
                  >
                    <option key={0} value="">
                      {commonLabels.COMBO_SELECT}
                    </option>
                    {allYearList &&
                      allYearList.length > 0 &&
                      allYearList
                        .filter(
                          (element) =>
                            element.isDeleted == false &&
                            element.isActive === true
                        )
                        .map((element, index) => (
                          <option key={index} value={element.id}>
                            {`${element.advertisementNo}/${element.year} - ${element.name}`}
                          </option>
                        ))}
                  </select>
                  {_.get("selectedAdvertiseNo.type", errors) ===
                    "required" && (
                      <p className="errorText float-left">
                        {commonLabels.MANDATORY_FIELD_MESSAGE}
                      </p>
                    )}
                </div>

                <div className="form-group col-md-4">
                  <label className="float-left">
                    {label.SelectExam}
                    <span className="errorText">*</span>
                  </label>
                  <select
                    className="form-control"
                    name="selectedExam"
                    ref={register({ required: true })}
                    onChange={(e) => {
                      onExamChange(e.target.value);
                    }}
                  >
                    <option key={0} value="">
                      {commonLabels.COMBO_SELECT}
                    </option>
                    {
                      examList &&
                      examList.length > 0 &&
                      examList
                        .filter(
                          (element) =>
                            element.isDeleted == false &&
                            element.isActive === true
                        )
                        .map((element, index) => (
                          <option key={index} value={element.id}>
                            {element.name}
                          </option>
                        ))
                    }
                  </select>
                  {_.get("selectedExam.type", errors) === "required" && (
                    <p className="errorText float-left">
                      {commonLabels.MANDATORY_FIELD_MESSAGE}
                    </p>
                  )}
                </div>
                {/* <div className="form-group col-md-4">
                  <label className="float-left">
                    {label.SelectSubject}
                    <span className="errorText">*</span>
                  </label>
                  <select
                    className="form-control"
                    name="selectedSubject"
                    ref={register({ required: true })}
                    onChange={(e) => {
                      onSubjectChange(e.target.value);
                    }}
                  >
                    <option key={0} value="">
                      {commonLabels.COMBO_SELECT}
                    </option>
                    {
                      subjectList &&
                      subjectList.length > 0 &&
                      subjectList
                        .filter(
                          (element) =>
                            element.isDeleted == false &&
                            element.isActive === true
                        )
                        .map((element, index) => (
                          <option key={index} value={element.id}>
                            {element.name}
                          </option>
                        ))
                    }
                  </select>
                  {_.get("selectedSubject.type", errors) === "required" && (
                    <p className="errorText float-left">
                      {commonLabels.MANDATORY_FIELD_MESSAGE}
                    </p>
                  )}
                </div> */}

              </div>

              <div className="row">
                <div className="form-group col-md-8">
                  {(session.roleName == 'superadmin' || session.roleName == 'secretary' || session.roleName == 'desk officer') &&
                    <>     <button
                      type="reset"
                      className="btn btn-secondary mr-2"
                      onClick={() => onCancelButton()}
                    >
                      {commonLabels.BUTTON_CANCEL}
                    </button>

                      <button
                        type="submit"
                        className="btn btn-primary mr-2"
                        disabled={saveButtonFlag}
                        onClick={handleSubmit((e) => {
                          onSubmit(e);
                          setConfirmClicked(true);
                        })}
                      >
                        {commonLabels.BUTTON_VIEW}
                      </button>
                    </>}
                  {(session.roleName == 'superadmin' || session.roleName == 'secretary') && (statisticalReportData && statisticalReportData?.presentAbsentCountDtos?.length > 0) &&
                    <button
                      type="button"
                      className="btn btn-primary mr-2"
                      disabled={(printFlag) || (pdfPrintDisabled)}
                      onClick={() => {
                        downloadPdf();
                      }}

                    >
                      {commonLabels.BUTTON_PRINT}
                    </button>}

                </div>
              </div>
            </div>
          </form>
        </div>
      </div>

      {statisticalReportData && statisticalReportData?.presentAbsentCountDtos?.length > 0 && (
        <div ref={pdfRef} className="answerKeyTable" id="InterviewReport">

          <table className="table text-center border-dark">
            <thead>
              <tr>
                <th className="border text-left">{label.Center}</th>
                <th className="border">{label.Present}</th>
                <th className="border">{label.Absent}</th>
                <th className="border">{label.Total}</th>

              </tr>
            </thead>
            <tbody>
              {statisticalReportData?.presentAbsentCountDtos?.map((ele, index) => (
                <tr key={index}>
                  <td className="border text-left"> {ele.examCenterName}</td>
                  <td className="border">{ele.present}</td>
                  <td className="border">{ele.absent}</td>
                  <td className="border">{ele.totalCount}</td>
                </tr>
              ))}
              <tr key={statisticalReportData?.presentAbsentCountDtos.length}>
                <td className="border text-right"> <strong>{label.GrandTotal}</strong></td>
                <td className="border"><strong>{statisticalReportData?.presentTotalCount}</strong></td>
                <td className="border"><strong>{statisticalReportData?.absentTotalCount}</strong></td>
                <td className="border"><strong>{statisticalReportData?.grandTotalCount}</strong></td>
              </tr>
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
};

export default PresentAbsentReport;
